module.exports = __webpack_public_path__ + "4c6de282d36a26fbad2feb65660940bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_8.jpg
// module id = 1722
// module chunks = 5